import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useIntl } from 'react-intl';
import gql from 'graphql-tag';
import useQuery from '../../../../modules/react/hooks/useQuery';
import Map from '../../../components/stateful/Map';
import { MarkerFragment } from '../../../components/stateful/Map/FacilityPopupContent';
import styles from './MapboxMapAllFacilities.scss';

const GET_FACILITIES = gql`
  query GetFacilitiesMapData(
    $filter: FacilitiesFilterInput!
    $locale: String!
  ) {
    facilities(filter: $filter) {
      edges {
        node {
          id
          address {
            longitude
            latitude
          }
          ...FacilitiesMapMarkerFacility
        }
      }
    }
  }

  ${MarkerFragment}
`;

const propTypes = {
  zoom: PropTypes.number,
  center: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }),
  mapProps: PropTypes.shape({
    zoom: PropTypes.number,
    center: PropTypes.shape({
      latitude: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired,
    }),
  }),
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  pageFacilityId: PropTypes.string,
};

const defaultProps = {
  mapProps: {},
  style: {},
  className: {},
  center: undefined,
  zoom: undefined,
  pageFacilityId: undefined,
};

const MapboxMapAllFacilities = ({
  center,
  mapProps,
  zoom,
  style,
  className,
  pageFacilityId,
  enableClustering,
  clusterRadius,
  colors,
  mapStyle,
}) => {
  const { locale } = useIntl();
  const { data } = useQuery(GET_FACILITIES, {
    variables: { locale, filter: { live: true } },
  });

  if (!data?.facilities?.edges?.length) {
    return <div />;
  }

  return (
    <div className={cx(styles.bigMap, className)} style={style}>
      <Map
        center={center}
        zoom={zoom}
        facilities={data.facilities.edges.map(({ node: facility }) => ({
          ...facility,
          longitude: facility.address.longitude,
          latitude: facility.address.latitude,
          isPrimary: facility.id === pageFacilityId,
        }))}
        enableClustering={enableClustering}
        clusterRadius={clusterRadius}
        colors={colors}
        mapStyle={mapStyle}
        // enableClustering
        {...mapProps}
      />
    </div>
  );
};

MapboxMapAllFacilities.propTypes = propTypes;
MapboxMapAllFacilities.defaultProps = defaultProps;

export default MapboxMapAllFacilities;
